// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPeakUsageIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18.97 21.245H4.161q-.702 0-1.01-.612-.307-.612.097-1.184l4.634-6.499q.317-.453.799-.699.48-.245 1.047-.245h3.888l5.634-6.572q.516-.597 1.256-.327.739.27.739 1.066V18.97q0 .945-.665 1.61t-1.61.665M7.44 10.006l-3.064 4.315a1.1 1.1 0 0 1-.737.466 1.1 1.1 0 0 1-.848-.205 1.1 1.1 0 0 1-.467-.74 1.1 1.1 0 0 1 .206-.851l3.083-4.296a2.24 2.24 0 0 1 1.852-.964h3.888l4.008-4.677q.31-.367.77-.398.46-.03.827.28t.398.77q.03.46-.28.827L13.068 9.21a2.05 2.05 0 0 1-.77.594 2.3 2.3 0 0 1-.945.202z" />
  </g>
);
export default SvgPeakUsageIcon;
SvgPeakUsageIcon.displayName = 'SvgPeakUsageIcon';
